import { Button, Divider, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { TimeField } from '@mui/x-date-pickers';
import DateInput from './DateInput/Index';
import { criarDataDeISO } from '../global/dataDigitada';
import SelectTopics from './SelectTopics';

export default ({ values, setValues, setFieldValue, handleChange, errors, handleReset, handleSubmit }) => {
    return (
        <>
            <Grid item xs md={3}>
                <Typography sx={{ pb: 2 }} variant="h5">
                    Pesquisa
                </Typography>

                <Grid container rowGap={2}>
                    <Grid item xs={12}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Nome ou username do anfitrião"
                            name="seller_name"
                            type="text"
                            onChange={handleChange}
                            value={values.seller_name || ''}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <SelectTopics
                            size="small"
                            value={values.topics}
                            name="topics"
                            onChange={setFieldValue}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            size="small"
                            fullWidth
                            label="Titúlo do encontro"
                            name="title"
                            type="text"
                            onChange={handleChange}
                            value={values.title || ''}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DateInput
                            label="Data"
                            name="date"
                            value={values.date || ''}
                            onChange={iso => setFieldValue('date', iso ? criarDataDeISO(iso) : null)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TimeField
                            size="small"
                            fullWidth
                            label="Horário"
                            name="time"
                            format="HH:mm"
                            ampm={false}
                            value={values.time || null}
                            onChange={(newValue) => setFieldValue('time', newValue)}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl>
                            <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                                <FormControlLabel
                                    value={true}
                                    onChange={handleChange}
                                    checked={String(values.visible_public) === 'true'}
                                    name="visible_public"
                                    control={<Radio />}
                                    label="Público"
                                />
                                <FormControlLabel
                                    value={false}
                                    onChange={handleChange}
                                    checked={String(values.visible_public) === 'false'}
                                    name="visible_public"
                                    control={<Radio />}
                                    label="Privado"
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl>
                            <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                                <FormControlLabel
                                    value={true}
                                    onChange={handleChange}
                                    checked={String(values.raffle) === 'true'}
                                    name="raffle"
                                    control={<Radio />}
                                    label="Seleção"
                                />
                                <FormControlLabel
                                    value={false}
                                    onChange={handleChange}
                                    checked={String(values.raffle) === 'false'}
                                    name="raffle"
                                    control={<Radio />}
                                    label="Agendamento"
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <Button fullWidth variant="contained" onClick={handleSubmit}>
                            Pesquisar
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            fullWidth
                            onClick={() => {
                                setValues({
                                    seller_name: '',
                                    topics: [],
                                    title: '',
                                    date: null,
                                    time: null,
                                    visible_public: '',
                                    raffle: '',
                                });
                                handleSubmit();
                            }}>
                            Limpar pesquisa
                        </Button>
                    </Grid>
                </Grid>
                <Divider orientation="vertical" flexItem />
            </Grid>
        </>
    );
};
